export class UserPermissionModal {
  userPermissionId?: number;
  userId: number;
  productId: number;
  view: boolean;
  addEdit: boolean;
  delete: boolean;
  createdBy: number;
  productName: string;
}
